// removed by extract-text-webpack-plugin
module.exports = {"container":"-JJfifv","bagTitle":"_1vvMfU_"};


//////////////////
// WEBPACK FOOTER
// ./template/components/MiniBag/Header/index.css
// module id = ./template/components/MiniBag/Header/index.css
// module chunks = client.sitechrome